<template>
  <v-form @submit.prevent ref="form" v-model="valid">
    <service-form :doc="doc" />
    <v-btn class="mt-5" color="amber" light @click="onSubmit">{{
      buttonText
    }}</v-btn>
    <v-btn class="mt-5" color="amber lighten-3 ml-2" light @click="onCancel"
      >Close</v-btn
    >
  </v-form>
</template>

<script>
// @ is an alias to /src
import ServiceForm from "./ServiceForm";

export default {
  name: "UserServiceFormAddUser",
  components: {
    ServiceForm,
  },
  data() {
    return {
      valid: true,
      doc: this.value,
    };
  },
  computed: {
    buttonText() {
      return this.edit ? "Update" : "Add";
    },
  },
  props: {
    value: Object,
    edit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onSubmit() {
      this.edit
        ? this.$emit("updateNote", this.doc)
        : this.$emit("saveNote", this.doc);
    },
    onCancel() {
      this.$emit("cancel");
    },
    populateField(field) {
      return field ? field : null;
    },
    validate() {
      this.$refs.form.validate();
    },
  },
};
</script>
